import React, { useMemo } from "react";
import type { ResultOf } from "gql.tada";
import { Select } from "components/Select/Select";
import type { ProjectListTitlesAndIds } from "api/queries";
import { useFilteredProjects } from "hooks/productHooks/useFilteredProjects";
import { useProject } from "stores/project";
import { useChangeProject } from "./hooks/useChangeProject";

type ProjectSelectProps = {
  data: ResultOf<typeof ProjectListTitlesAndIds> | undefined;
};

export const ProjectSelect = ({ data }: ProjectSelectProps) => {
  const project = useProject();
  const onChange = useChangeProject();

  const filteredProjects = useFilteredProjects(
    data?.currentUser?.projectList?.items || [],
  );

  const options = useMemo(() => {
    return filteredProjects.map((project) => ({
      label: project?.title ?? "",
      value: project?.id ?? "",
    }));
  }, [filteredProjects]);

  const selectedOption = useMemo(
    () => options?.find((option) => option.value === project?.id),
    [options, project?.id],
  );

  return (
    <Select
      onChange={onChange}
      options={options}
      value={selectedOption}
      name="productSelect"
      testId="project-select"
    />
  );
};
